import { useEffect, useState } from "react";
import HeroSection from "@/pages/home/components/HeroSection";
import VideoSeries from "@/pages/home/components/VideoSeries";
import Creators from "@/pages/home/components/Creators";
import TalentGallery from "@/pages/home/components/TalentGallery";
import MessageEntry from "@/pages/home/components/MessageEntry";
import { Navbar, Footer } from "@/pages/home/components/Layout";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://example.com";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      "url": `${SITE_URL}/`,
      "name": "トラックボーイズ",
      "description": "「トラックボーイズ」の公式サイト。長距離運行・初心者向け解説・あるある歌シリーズなど、運送業のリアルを笑えるバラエティで届けるYouTubeチャンネル。",
      "inLanguage": "ja",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${SITE_URL}/?s={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "WebPage",
      "@id": `${SITE_URL}/#webpage`,
      "url": `${SITE_URL}/`,
      "name": "トラックボーイズ｜トラックドライバーの笑えるリアルを発信中！",
      "description": "「トラックボーイズ」の公式サイト。長距離運行・初心者向け解説・あるある歌シリーズなど、運送業のリアルを笑えるバラエティで届けるYouTubeチャンネル。",
      "isPartOf": { "@id": `${SITE_URL}/#website` },
      "inLanguage": "ja",
      "dateModified": "2026-04-03"
    },
    {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      "name": "トラックボーイズ",
      "url": `${SITE_URL}/`,
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/0db9e218ed4dd3e1bbdcabf75b408cd1.png"
      },
      "sameAs": [
        "https://www.youtube.com/@truckboys"
      ]
    },
    {
      "@type": "VideoObject",
      "name": "ふるせ 代表動画",
      "description": "トラックボーイズ・ふるせの代表動画",
      "thumbnailUrl": "https://img.youtube.com/vi/d8JeOmb_czI/hqdefault.jpg",
      "url": "https://youtu.be/d8JeOmb_czI",
      "embedUrl": "https://www.youtube.com/embed/d8JeOmb_czI",
      "uploadDate": "2024-01-01",
      "inLanguage": "ja"
    },
    {
      "@type": "VideoObject",
      "name": "水野 代表動画",
      "description": "トラックボーイズ・水野の代表動画",
      "thumbnailUrl": "https://img.youtube.com/vi/0d6bR_HHs78/hqdefault.jpg",
      "url": "https://youtu.be/0d6bR_HHs78",
      "embedUrl": "https://www.youtube.com/embed/0d6bR_HHs78",
      "uploadDate": "2024-01-01",
      "inLanguage": "ja"
    },
    {
      "@type": "VideoObject",
      "name": "さくや 代表動画",
      "description": "トラックボーイズ・さくやの代表動画",
      "thumbnailUrl": "https://img.youtube.com/vi/R7rqX7rT7FI/hqdefault.jpg",
      "url": "https://www.youtube.com/watch?v=R7rqX7rT7FI",
      "embedUrl": "https://www.youtube.com/embed/R7rqX7rT7FI",
      "uploadDate": "2024-01-01",
      "inLanguage": "ja"
    },
    {
      "@type": "VideoObject",
      "name": "たまき 代表動画",
      "description": "トラックボーイズ・たまきの代表動画",
      "thumbnailUrl": "https://img.youtube.com/vi/_BLSTG6sFv4/hqdefault.jpg",
      "url": "https://youtu.be/_BLSTG6sFv4",
      "embedUrl": "https://www.youtube.com/embed/_BLSTG6sFv4",
      "uploadDate": "2024-01-01",
      "inLanguage": "ja"
    },
    {
      "@type": "VideoObject",
      "name": "ほまちゃん 代表動画",
      "description": "トラックボーイズ・ほまちゃんの代表動画",
      "thumbnailUrl": "https://img.youtube.com/vi/nkU9MusUFXQ/hqdefault.jpg",
      "url": "https://youtu.be/nkU9MusUFXQ",
      "embedUrl": "https://www.youtube.com/embed/nkU9MusUFXQ",
      "uploadDate": "2024-01-01",
      "inLanguage": "ja"
    }
  ]
};

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "home-jsonld";
    script.textContent = JSON.stringify(homeJsonLd);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById("home-jsonld");
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="bg-white min-h-screen" style={{ fontFamily: "'M PLUS 1p', 'Noto Sans JP', sans-serif" }}>
      <Navbar scrolled={scrolled} />
      <main>
        <HeroSection />
        <VideoSeries />
        <Creators />
        <TalentGallery />
        <MessageEntry />
      </main>
      <Footer />
    </div>
  );
}
